<template>
  <div id="app">
    <!-- 地图控件显示区域 -->
    <div id="map"></div>
    <!-- mask蒙层显示区域 -->
    <div class="mask"></div>
    <!-- 路由区域 -->
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>

import {mapActions,mapMutations,mapState,mapGetters} from "vuex";	
export default {
  data() {
    return {
      // 单例map实例数据,勿操作
      _singleMapData: null,
     pointsObj: [
        // { x: 108.3660499700, y: 34.4643944200 },
        // { x: 108.3200000000, y: 34.4855000000 },
        // { x: 108.3720000000, y: 34.4810000000 },
        // { x: 108.3490000000, y: 34.4699000000 },
        // { x: 108.4010000000, y: 34.4714000000 },
        // { x: 108.1990000000, y: 34.4288000000 },
        // { x: 108.1940000000, y: 34.4671000000 },
        // { x: 108.3660000000, y: 34.4980000000 }
      ],
	  regionName:'',
	  isRouterAlive: true
    };
  },
  watch:{
	async '$route' (to, from) { //监听路由是否变化
		//if(to.path == "/home"){ //跳转到哪个页面
			//location.reload()；
			// console.log("to",to)
			// console.log("from",from)
			await this.getRegionNames().then(res => {
				this.regionName = res.orgareaname;
			});
			await this.setLocation();
			// 创建map实例
			await this._singleMap();
			await this.getCodeData();
		//}
	}
  },
  computed:{
	  ...mapState(['regionId']),
	  ...mapGetters(['orgIdNum'])
  },
  mounted() {  
	// let result =  JSON.parse(localStorage.getItem("loginUserInfo"))
	// if(result) {
	// 	let {district} = result.sysUser;
	// 	if(district != this.regionId) {
	// 		localStorage.clear();
	// 		this.$router.push("/login")
	// 	}	
	// } else {
	// 	localStorage.clear();
	// 	this.$router.push("/login")	
	// }
	
  },
  methods: {
	...mapActions(['getEnterprise','getCodeData','getRegionNames']),
	...mapMutations(['setOrgIdNum']),
	reload () {
	    this.isRouterAlive = false;            //先关闭，
	    this.$nextTick(function () {
	        this.isRouterAlive = true;         //再打开
	    }) 
	},
	//赋值溯源企业经纬度
	 async setLocation() {
		 this.pointsObj = [];
		//  if(localStorage.getItem("loginUserInfo"))
		//  {
			await this.getEnterprise()
			.then(res => {
				if(res)
				{
					res.forEach(item => {
						if(item.lng && item.lng != '' && item.lat && item.lat != '')
						{
							this.pointsObj.push({
                              y:item.lng,
                              x:item.lat,
								org_id:item.org_id
							});
						}
					});	
					window.sessionStorage.setItem("orgList", JSON.stringify(res))  
				}
			}).catch(err =>{
				console.log('getEnterprise',err)
			}); 
		 //}
	 },
    //单例创建map
    _singleMap() {
      // 单例开启map,在app组件里的话可能用不到单例,可以用作扩展,
     // if (!this._singleMapData) {
     //    this._singleMapData = 
		this._createMap();
    //  }
    //   return this._singleMapData;
    },
    //创建map控件
    _createMap() {
      // 创建map实例,
      const map = new BMap.Map("map");
	  var localSearch = new BMap.LocalSearch(map);
　　localSearch.setSearchCompleteCallback(function (searchResult) {
　　　　var poi = searchResult.getPoi(0);
	  // 初始化地图,设置中心点坐标和地图级别，
     map.centerAndZoom(new BMap.Point(poi.point.lng, poi.point.lat), 11);
　　});
　　localSearch.search(this.regionName);
	  
	  
      
      //添加地图类型控件,
      map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
        })
      );
      //设置地图显示的城市，
      map.setCurrentCity("北京");
      //在百度地图后台发布一份主题设置背景色和主题,
      map.setMapStyle({ style: "midnight" });
      //开启地图缩放,
      map.enableScrollWheelZoom(true);
      //圈出行政边界函数执行,
      this._getBoundary(map);
      //标点开始
      this._getPointMarker(map,this.pointsObj);
	 // console.log("this.pointsObj",this.pointsObj.length)
      return map;
    },
    //获取行政区域边界,
    _getBoundary(map) {
      const bdary = new BMap.Boundary();
      bdary.get(this.regionName, result => {
        //从回调函数中拿到行政区域的点,
        const areaPoints = result.boundaries.length;
        const areaPointsInfo = result.boundaries;
        let pointArray = [];
        //一般只有一个点,为了扩展,用到for循环
        for (let i = 0; i < areaPoints; i++) {
          //开始绘制,
          let stroke = new BMap.Polygon(areaPointsInfo[i], {
            strokeWeight: 2, //设置多边形线的粗细,
            strokeColor: "#FFAA25" //设置多边形线的颜色,
          });
          pointArray = pointArray.concat(stroke.getPath());
          stroke.setFillColor("#397678"); //填充中心颜色,
          //创建行政边界,
          map.addOverlay(stroke);
        }
      });
    },
    //获取标记点,
    _getPointMarker(map, pointsObj) {
      //最终拿到地理坐标点的数组
      let pointArr = [];
	  
      //需要创建地理坐标的数据
      //第一轮for循环在创建坐标点
      for (let point = 0, len = pointsObj.length; point < len; point++) {
		pointArr.push(this._createPoints(pointsObj[point]));
      }
      //第二轮for循环正式把生成的坐标点加上样式推入地图中
      for (let i = 0, len = pointArr.length; i < len; i++) {
        let marker = new BMap.Marker(pointArr[i]);
        let label = new BMap.Label(i + 1, {
          offset: new BMap.Size(5, 4)
        });
        label.setStyle({
          background: "none",
          color: "#fff",
          border: "none"
        });
        //显示label
        marker.setLabel(label);
        //插入标点
        map.addOverlay(marker);
        //点击事件,违背了单一指责原则,但是我太累了不想在抽离出去了,
        marker.addEventListener("click", () => {
          this.openCompanyInfo.call(this,i);
        });
      }
    },
    //生成标记点
    _createPoints({ x, y }) {
		return new BMap.Point(x, y);
    },
    //点击后执行的具体函数
    openCompanyInfo(data) {
      //公司id数据,
	 // console.log("this.pointsObj====",this.pointsObj[data])
	 const Id = this.pointsObj[data].org_id;
	 this.setOrgIdNum(Id)
      //推入company路由
     this.$router.push({name:'company'});
    }
  }
};
</script>

<style lang="less">
//地图控件大概样式,
#map {
  position: absolute;
  width: 100%;
  // height: 800px;
  height: 100%;
  min-height: 900px;
}
//蒙层样式,
.mask {
  z-index: 900;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: 900px;
  background-color: rgba(8, 16, 16, 0.6);
  // pointer-events,鼠标穿透
  pointer-events: none;
}

#video{
	height: 280px!important;
}
</style>
